import React from "react";
import ModalB from "react-bootstrap/Modal";
import { Link } from "react-router-dom";

function linhasPerfil(perfil) {
  if (!perfil || perfil === "null") return [];
  return String(perfil).split(/\r\n|\r|\n/);
}

function ModalPatrocinador(props) {
  const handleModal = () => props.toggleModal();
  const linhas = linhasPerfil(props?.item?.perfil);
  const nome = props?.item?.patrocinador || "Patrocinador";

  return (
    <ModalB show={props.show} onHide={handleModal} centered>
      <ModalB.Header closeButton style={{ color: "white" }}>
        <ModalB.Title className="titulo-modal" style={{ color: "white" }}>
          {nome}
        </ModalB.Title>
      </ModalB.Header>
      <ModalB.Body>
        <article className="modal-perfil" aria-label={`Perfil de ${nome}`}>
          {props?.item?.logo ? (
            <img
              src={props.item.logo}
              alt={`Logo de ${nome}`}
              className="imagem-logo-modal"
            />
          ) : null}

          {linhas.length > 0 ? (
            <div className="texto-modal-perfil">
              {linhas.map((linha, index) => (
                <React.Fragment key={index}>
                  {linha}
                  {index < linhas.length - 1 ? <br /> : null}
                </React.Fragment>
              ))}
            </div>
          ) : null}
        </article>
      </ModalB.Body>
      {props.to ? (
        <ModalB.Footer>
          <Link to={props.to} onClick={handleModal} className="link-padrao">
            {props.labelTo}
          </Link>
        </ModalB.Footer>
      ) : null}
    </ModalB>
  );
}

export default ModalPatrocinador;
